/**
 * Cookie storage helper for cross-subdomain support
 */

export const setCookie = (name, value, days = 30) => {
    let expires = "";
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    
    // Automatically determine domain for subdomains
    // e.g., app1.fittools.cc and app2.fittools.cc -> .fittools.cc
    const hostname = window.location.hostname;
    let domain = "";
    const parts = hostname.split('.');
    if (parts.length >= 2) {
        // Simple logic for common domains like fittools.cc
        // For more complex ones like .com.cn, more logic would be needed
        const mainDomain = parts.slice(-2).join('.');
        domain = "; domain=." + mainDomain;
    }

    document.cookie = name + "=" + (encodeURIComponent(value) || "") + expires + "; path=/" + domain;
};

export const getCookie = (name) => {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length, c.length));
    }
    return null;
};

export const eraseCookie = (name) => {
    const hostname = window.location.hostname;
    const parts = hostname.split('.');
    let domain = "";
    if (parts.length >= 2) {
        const mainDomain = parts.slice(-2).join('.');
        domain = "; domain=." + mainDomain;
    }
    document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;' + domain;
};

